import { render, staticRenderFns } from "./UserLogout.vue?vue&type=template&id=14a5a052&scoped=true"
import script from "./UserLogout.vue?vue&type=script&lang=js"
export * from "./UserLogout.vue?vue&type=script&lang=js"
import style0 from "./UserLogout.vue?vue&type=style&index=0&id=14a5a052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a5a052",
  null
  
)

export default component.exports